import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=02670e49&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=02670e49&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02670e49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02670e49')) {
      api.createRecord('02670e49', component.options)
    } else {
      api.reload('02670e49', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=02670e49&scoped=true", function () {
      api.rerender('02670e49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/sharing_agreement/direct_investment_event/viewReward/detail.vue"
export default component.exports